import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule } from '@angular/forms';
import { CardsTypeSelector } from '../../../../models/cards-type-selector';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-cards-selector',
  templateUrl: './bary-cards-selector.component.html',
  styleUrls: ['./bary-cards-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryCardsSelectorComponent implements OnInit {
  @Input() control = new FormControl('');
  @Input() cards: Array<CardsTypeSelector> = [];

  @Output() valueChanges = new EventEmitter();

  protected readonly FAS = FaDirectiveEnum.FAS;

  ngOnInit(): void {
    this.deactivateOthers(this.control.value);
  }

  deactivateOthers(value: any) {
    this.cards.forEach(elt => {
      if (elt.value === value && !elt.disabled) {
        elt.selected = true;
        this.valueChanges.emit(value);
        this.control.setValue(elt.value);
      } else {
        elt.selected = false;
      }
    });
  }
}
